import Vue from 'vue'
import router from './routes'
import store from './store';
import App from './App.vue'

try {
    window.Popper = require('popper.js').default
    window.$ = window.jQuery = require('jquery')
    require('bootstrap');
} catch (e) {
    console.log('Failed to load Library');
}

window.api = {url: process.env.VUE_APP_API_URL};
window.axios = require('axios');
window._ = require('lodash')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json, plain/text';

window.axios.defaults.baseURL = window.api.url ?? '/api';
window.axios.defaults.withCredentials = true;

window.events = new Vue();

window.flash = function (message, level = 'success') {
	window.events.$emit('flash', { message, level });
};

/**
* We'll load the axios HTTP library which allows us to easily issue requests
* to our Laravel back-end. This library automatically handles sending the
* CSRF token as a header based on the value of the "XSRF" token cookie.
*/

import './sass/app.scss'

Vue.config.productionTip = false

// Now the app has started!

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

